/*
 * @Author: Ygm
 * @Date: 2024-10-29 10:53:51
 * @LastEditors: Ygm
 * @LastEditTime: 2026-01-07 14:39:01
 * @Description: 水印
 */

let observer = null // 定义全局 observer
let currentScale = 1 // 存储当前缩放倍数，默认1倍
let resizeObserver = null // 监听浏览器缩放
let initialDevicePixelRatio = window.devicePixelRatio // 记录初始设备像素比
let currentText = null // 存储当前水印文字
let currentParentNode = null // 存储当前水印挂载的父节点

export function createWatermark(text, scale = 1, parentNode = null) {
  currentText = text
  currentScale = scale
  currentParentNode = parentNode || document.body

  // 初始化全屏水印
  addWatermark(text, scale, parentNode)
  // 添加 MutationObserver 监控水印是否被篡改
  observeWatermark(text, scale, parentNode)
  // 监听浏览器缩放
  observeBrowserZoom(parentNode)
}

export function removeWatermark() {
  // 移除水印和观察器
  removeWatermarkElement()
  disconnectObserver()
  disconnectResizeObserver()
}

export function updateWatermark(text, scale = 1, parentNode = null) {
  currentText = text
  currentScale = scale
  currentParentNode = parentNode || currentParentNode || document.body
  addWatermark(text, scale, parentNode)
}

function addWatermark(text, scale, parentNode = null) {
  const targetParentNode = parentNode || currentParentNode || document.body
  removeWatermarkElement(targetParentNode) // 确保之前的水印被移除

  const watermarkContainer = document.createElement('div')
  watermarkContainer.className = 'watermark-container'
  watermarkContainer.style.position = 'fixed'
  watermarkContainer.style.top = '0'
  watermarkContainer.style.left = '0'
  watermarkContainer.style.width = '100vw'
  watermarkContainer.style.height = '100vh'
  watermarkContainer.style.pointerEvents = 'none'
  watermarkContainer.style.zIndex = '10000000'
  watermarkContainer.style.overflow = 'hidden'

  const lines = Array.isArray(text) ? text : [text]

  // 根据当前设备像素比和缩放倍数计算实际缩放比例
  const currentDevicePixelRatio = window.devicePixelRatio
  const actualScale = scale * (initialDevicePixelRatio / currentDevicePixelRatio)

  // 基础间距和字体大小（在100%缩放下的值）
  const baseColumnGap = 360
  const baseRowGap = 150
  const baseFontSize = 17

  // 应用缩放后的值
  const scaledColumnGap = baseColumnGap * actualScale
  const scaledRowGap = baseRowGap * actualScale
  const scaledFontSize = baseFontSize * actualScale

  const columns = Math.ceil(window.innerWidth / scaledColumnGap)
  const rows = Math.ceil(window.innerHeight / scaledRowGap)

  for (let i = 0; i < rows; i++) {
    for (let j = 0; j < columns; j++) {
      lines.forEach((line, index) => {
        const watermark = document.createElement('div')
        watermark.style.position = 'absolute'
        watermark.style.opacity = '0.15'
        watermark.style.whiteSpace = 'nowrap'
        watermark.style.fontSize = `${scaledFontSize}px`
        watermark.style.color = 'rgba(0, 0, 0, 0.6)'
        watermark.style.transform = 'rotate(-30deg)'
        watermark.style.left = `${j * scaledColumnGap + index * 16 * actualScale}px`
        watermark.style.top = `${i * scaledRowGap + index * 18 * actualScale}px`

        watermark.innerText = line
        watermarkContainer.appendChild(watermark)
      })
    }
  }

  targetParentNode.appendChild(watermarkContainer)
}

function removeWatermarkElement(parentNode = null) {
  const targetParentNode = parentNode || currentParentNode || document.body
  const existingWatermark = targetParentNode.querySelector('.watermark-container')
  if (existingWatermark) {
    targetParentNode.removeChild(existingWatermark)
  }
}

function observeWatermark(text, scale, parentNode = null) {
  const targetParentNode = parentNode || currentParentNode || document.body

  observer = new MutationObserver(() => {
    const watermark = targetParentNode.querySelector('.watermark-container')
    if (!watermark) {
      addWatermark(text, scale, targetParentNode)
    }
  })

  observer.observe(targetParentNode, { childList: true })
}

function observeBrowserZoom(parentNode = null) {
  const targetParentNode = parentNode || currentParentNode || document.body

  // 使用 ResizeObserver 监听窗口尺寸变化
  resizeObserver = new ResizeObserver(entries => {
    // 防抖处理，避免频繁触发
    clearTimeout(resizeObserver.timeout)
    resizeObserver.timeout = setTimeout(() => {
      if (currentText) {
        addWatermark(currentText, currentScale, targetParentNode)
      }
    }, 100)
  })

  // 监听 body 尺寸变化
  resizeObserver.observe(targetParentNode)

  // 监听 devicePixelRatio 变化（某些浏览器的缩放会改变这个值）
  let lastDevicePixelRatio = window.devicePixelRatio
  const checkDevicePixelRatio = () => {
    const currentDevicePixelRatio = window.devicePixelRatio
    if (currentDevicePixelRatio !== lastDevicePixelRatio) {
      lastDevicePixelRatio = currentDevicePixelRatio
      if (currentText) {
        addWatermark(currentText, currentScale, targetParentNode)
      }
    }
  }

  // 每500ms检查一次 devicePixelRatio 变化
  setInterval(checkDevicePixelRatio, 500)
}

function disconnectObserver() {
  if (observer) {
    observer.disconnect()
    observer = null
  }
}

function disconnectResizeObserver() {
  if (resizeObserver) {
    resizeObserver.disconnect()
    resizeObserver = null
  }
}



// WEBPACK FOOTER //
// ./src/utils/watermark.js